
//Max size 5 MB
const MAX_ALLOWED_FILE_SIZE = 5 * 1024 * 1024
const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/heic',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]

function isValidFileSize(file: File): boolean {
  return file.size <= MAX_ALLOWED_FILE_SIZE
}

function isValidFileType(file: File): boolean {
  return ALLOWED_FILE_TYPES.includes(file.type)
}

function isValidFile(file: File): boolean {
  return isValidFileType(file) && isValidFileSize(file)
}

export {isValidFile, ALLOWED_FILE_TYPES}
